/**
 * Типы начислений Ozon (/v1/finance/accrual/types) — русские названия.
 *
 * Снимок справочника от 2026-09-16 (124 типа). Ozon добавляет типы редко;
 * неизвестный id подписывается «Тип N», а сумма по нему не теряется. Ключи —
 * type_id из строк finance_accrual_lines (см. миграцию 184).
 */

export const ACCRUAL_TYPE_LABELS: Record<number, string> = {
  1: "Эквайринг", // Acquiring
  2: "Обратная магистраль", // BackwardShipment
  3: "Продвижение бренда", // BrandCommission
  4: "Подключение продвижения бренда", // BrandPromotion
  5: "Брендовая полка", // BrandShelf
  6: "Обработка отменённых и невостребованных товаров", // Cancellation
  7: "Благотворительное пожертвование", // Charity
  8: "Начисления по претензиям", // ClaimCommission
  9: "Обработка возвратов", // ClientReturn
  10: "Компенсация", // Compensation
  11: "Инвентаризация взаиморасчетов", // CorrectionCommission
  12: "Кросс-докинг", // CrossDock
  13: "Организация выезда курьера", // CrossDockPickUpCourierDelivery
  14: "Обработка операционных ошибок продавца", // DefectRate
  15: "Утилизация", // Disposal
  16: "Обработка отправления Drop-off", // Drop-Off
  17: "Обработка отправления Drop-off партнёрами", // Drop-Off Agent
  18: "Досрочная выплата", // EarlyPayment
  19: "Внешнее продвижение", // ExternalPromotion
  20: "Гибкий график выплат", // FlexiblePayments
  21: "Сборка заказа", // Fulfillment
  22: "Рассрочка", // Installment
  23: "Реклама в сети Интернет на Сайте", // InternetSiteAdvertising
  24: "Перенос карточек товаров", // ItemCloning
  25: "Товарная компенсация", // ItemCompensation
  26: "Рассрочка для покупателей из Казахстана", // KazakhstanBuyerInstallment
  27: "Бейдж Оригинал", // LabelOriginal
  28: "Последняя миля", // LastMile
  29: "Доставка до места выдачи", // LastMileCourier
  30: "Выдача товара", // LastMilePickUpPoint
  31: "Лидогенерация для автодилеров", // LeadGeneration
  32: "Логистика", // Logistic
  33: "Рекламные услуги", // Marketing
  34: "Обязательная маркировка товаров", // Marking
  35: "Модерация товаров", // Moderation
  36: "Привлечение предварительных заказов", // OrdersBooking
  37: "Ozon Data", // OzonData
  38: "Обеспечение материалами для упаковки товара", // PackageCost
  39: "Упаковка товара партнёрами", // PackingFee
  40: "Обработка частичного невыкупа", // PartialReturn
  41: "Оплата за клик", // PayPerClick
  42: "Обработка отправления Pick-up", // Pick-Up
  43: "Организация выезда курьера", // PickUpCourierArrangement
  44: "Доставка курьером Pick-up", // PickUpCourierDelivery
  45: "Обработка возвратов, отмен и невыкупов партнёрами", // PickUpPointReturnAcceptance
  46: "Размещение товаров на складах Ozon", // Placements
  47: "Баллы за отзывы", // PointsForReviews
  48: "Бонусы продавца", // PremiumCashbackIndividualPoints
  49: "Услуга продвижения Premium", // PremiumCashbackPromotion
  50: "Бонусы продавца - рассылка", // PremiumMailingCommission
  51: "Подписка Premium Pro (процент)", // PremiumMembership
  52: "Подписка Premium", // PremiumSubscription
  53: "Подготовка товаров к возврату", // PreparingToReturn
  54: "Продвижение товара", // Promotion
  55: "Рассылка пуш-уведомлений", // PushCampaign
  56: "Обработка и логистика кванта", // QuantProcessingDrop
  57: "Корректировка стоимости услуг", // RealizationReportCorrection
  58: "Перемещение товаров между складами Ozon", // Replenishment
  59: "Обратная логистика", // ReturnFlowLogistic
  60: "Долгосрочное размещение возврата FBS", // ReturnStorageInTheWarehouse
  61: "Закрепление отзыва", // ReviewsPin
  62: "Перечисление за доставку от покупателя", // RfbsClientDeliveryCharge
  63: "Агентское вознаграждение Ozon Агрегатор realFBS", // RfbsDomesticAgentFee
  64: "Доставка Партнёром Ozon", // RfbsDomesticDelivery
  65: "Лёгкий возврат", // RfbsEasyReturn
  66: "Агентское вознаграждение Ozon", // RfbsGlobalAgentFee
  67: "Услуги международной доставки", // RfbsGlobalDelivery
  68: "Сервисный сбор за интеграцию с логистической платформой", // RfbsServiceFee
  69: "Вознаграждение за продажу", // SaleCommission
  70: "Приобретение отзывов на платформе", // SaleReview
  71: "Вывоз товара со склада силами Ozon", // SellerReturns
  72: "Взаимозачет требований между Договорами", // SetOff
  73: "Магистраль", // Shipment
  74: "Звёздные товары", // StarsMembership
  75: "Трафареты", // Stencil
  76: "Страхование товара от массовых повреждений", // StockInsurance
  77: "Обработка товара", // SupplyInbound
  78: "Краткосрочное размещение возврата FBS", // TemporaryPlacement
  79: "Временное размещение товара партнерами", // TemporaryPlacementsAgent
  80: "Генерация видеообложки", // VideoCover
  81: "Бонус за достижение цели продаж", // VolumeObligationReward
  82: "Дополнительная обработка ОВХ", // VolumeWeightCharacteristicsProcessing
  83: "Обеспечительные платежи", // BrandDeposit
  84: "Дополнительная упаковка на складе Ozon", // ItemPacking
  85: "Пломбирование товара", // ItemSealing
  86: "Дополнительная упаковка товара на ПВЗ в СНГ", // PackmanCisPacking
  87: "Реклама в социальных сетях", // SocialMediaAdvertising
  88: "Самовывоз", // ClickAndCollect
  89: "Запрещённый контент", // DefectFineModeration
  90: "Запрещённый товар", // DefectFineProhibitedGoods
  91: "Товар с нарушением интеллектуальных прав", // DefectFineCounterfeitGoods
  92: "Жалобы покупателей", // DefectFineComplaint
  93: "Превышение индекса ошибок", // DefectFineErrors
  94: "Отгрузка в нерекомендованный слот", // DefectFineShipmentDelayRate
  95: "Подписка Управление отзывами", // CustomerReviews
  96: "Ускоренный сбор отзывов", // AcceleratedReviewCollection
  97: "Обработка грузоместа", // PackageUnitProcessing
  98: "Доставка до места выдачи силами Ozon", // DeliveryToHandoverPlaceByOzon
  99: "Международная логистика", // InternationalLogisticDelta
  100: "Транспортно-экспедиционная услуга по организации международной перевозки", // OzonGlobalLogisticsDelivery
  101: "Обработка нестандартного товара", // OversizedExtraHandling
  102: "Временное размещение отправления в СЦ/ПВЗ/партнёрами", // B2CTemporaryPlacement
  103: "Утилизация отправления", // B2CDisposal
  104: "Страховое возмещение", // B2CInsuranceCompensation
  105: "Страхование отправления", // B2CInsuranceShipping
  106: "B2C Обработка отправления Drop-off", // B2C Drop-Off
  107: "B2C Обработка отправления Drop-off партнёрами", // B2C Drop-Off Agent
  108: "Обеспечение материалами для упаковки отправления", // B2CContainerPacking
  109: "Упаковка отправления партнёрами", // B2CContainerPackage
  110: "B2C Доставка до места выдачи партнёрами", // B2CCourierClientReinvoice
  111: "B2C Доставка до места выдачи силами Ozon", // B2CDeliveryToHandoverPlaceByOzon
  112: "B2C Выдача товара партнёрами", // B2CPickUpPointClientReinvoice
  113: "B2C Обработка возвратов, отмен и невыкупов партнёрами", // B2CPickUpPointReturnAcceptance
  114: "B2C Логистика", // B2CLogistics
  115: "B2C Обратная логистика", // B2CBackwardLogistics
  116: "Сбор первых отзывов", // FirstCustomerReview
  117: "Увеличение лимита на создание карточек товаров", // IncreaseAssortmentLimit
  118: "Бейдж «Бренд проверен»", // LabelBrandVerified
  119: "Баллы в чате с покупателем", // CustomerChatPoints
  120: "Доставка до СЦ силами Ozon", // CourierPickUpByOzon
  121: "Доставка до СЦ партнёрами", // CourierPickUpReinvoice
  122: "Услуги по заключению договора на организацию международной перевозки", // RfbsGlobalIntermediaryService
  123: "Электронная услуга подключения к логистической Платформе Ozon", // RfbsGlobalPlatformConnectionService
  124: "Перечисление за доставку от покупателя", // RfbsBuyerDelivery
};

export function accrualTypeLabel(typeId: number): string {
  return ACCRUAL_TYPE_LABELS[typeId] ?? (typeId > 0 ? `Тип ${typeId}` : "Без типа");
}
